const style = {
  simpleColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  simpleRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  spaceBetweenRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    verticalAlign: 'middle',
    alignItems: 'center',
  },
  inputContainers: {
    marginTop: 10,
  },
  bottomFields: {
    display: 'flex',
    flexDirection: 'column',
    width: '32%',
  },
};

export default style;
